import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlashlightOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flashlight_off"}/>
}
